import './FilterMenuComponent.scss';
import FilterComponent from '../generic-filter/FilterComponent';
import { ScreenType, viewModeType } from '../../../common/view-model';
import { RootState } from '../../../redux/AppReducer';
import { useSelector } from 'react-redux';
import { AppActions } from '../../../redux/AppActions';
import { FC, useEffect } from 'react';
import HideFilterComponent from '../hide-filter/HideFilterComponent';
import { isCurrentUserAnonymous } from '../../../helpers/authenticationHelper';
import { UserActions } from '../../../redux/UserActions';
import { useAppDispatch } from '../../../redux/store';
export interface IFilterMenuComponentProps {
	handelClosePanel?: () => void;
	viewMode: viewModeType;
	onClearAnimation?: () => void;
	mobileFilterPanelRef?: React.RefObject<HTMLDivElement>;
}
const FilterMenuComponent: FC<IFilterMenuComponentProps> = ({
	handelClosePanel,
	viewMode,
	onClearAnimation,
	mobileFilterPanelRef
}) => {
	const dispatch = useAppDispatch();
	const handleClearModalContent = () => dispatch(AppActions.setModalContent(undefined));
	const setHasClickOnFilter = (hasClicked: boolean) =>
		dispatch(UserActions.clickOnFilter(hasClicked));
	const deviceScreen = useSelector((state: RootState) => state.appState.deviceScreen);
	const hasClickOnFilter = useSelector(
		(state: RootState) => state.appState.userState?.hasClickOnFilter
	);
	const handleClose = () => {
		if (deviceScreen == ScreenType.TABLET) {
			handleClearModalContent();
		}
		handelClosePanel && handelClosePanel();
	};
	useEffect(() => {
		return () => {
			if (deviceScreen == ScreenType.TABLET && onClearAnimation) {
				onClearAnimation();
			}
		};
	}, []);
	useEffect(() => {
		setHasClickOnFilter(false);
	}, []);
	useEffect(() => {
		if (
			hasClickOnFilter &&
			isCurrentUserAnonymous() &&
			(deviceScreen === ScreenType.TABLET || deviceScreen === ScreenType.MOBILE)
		) {
			handelClosePanel && handelClosePanel();
			setHasClickOnFilter(false);
		}
	}, [deviceScreen, hasClickOnFilter]);
	return (
		<div
			ref={deviceScreen === ScreenType.MOBILE ? mobileFilterPanelRef : null}
			className={`filter-menu ${deviceScreen == ScreenType.TABLET ? 'tablet-container' : ''}`}
		>
			<HideFilterComponent hideFilterHandler={handleClose} deviceViewMode={viewMode} />
			<FilterComponent
				onClose={handleClose}
				setCurrentCategory={function (category?: string): void {
					throw new Error('Function not implemented.');
				}}
				currentCategory={''}
				productsPageUrl={''}
				setLockModalContent={function (): void {
					throw new Error('Function not implemented.');
				}}
				registerUserClickEvent={function (event: string): void {
					throw new Error('Function not implemented.');
				}}
				clearAllFilters={function (): void {
					throw new Error('Function not implemented.');
				}}
			/>
		</div>
	);
};

export default FilterMenuComponent;
